import { ConvictionCandleLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setups/ConvictionCandleLine';
import { ConvictionCandleTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/setups/ConvictionCandleTacticPanel';
import { ConvictionCandleWrapper } from '../../../../components/displays/tradeplans/softOrderModules/setupModules/ConvictionCandleModule/wrapper/ConvictionCandleWrapper';
import ConvictionCandleDoc from '../../../../components/forms/tradeplans/documentation/ConvictionCandleDocumenation';
import { ConvictionCandleData } from './convictionCandleData';
import { validateConvictionCandle } from './validateConvictionCandle';

export const ConvictionCandle = {
  //data class
  dataStore: ConvictionCandleData,

  //string constants
  name: 'CONVICTION_CANDLE',
  tacticLabel: 'Conviction Candle',
  addTacticLabel: 'Add Conviction Candle',
  category: 'Setup',
  
  //components
  tradePlanFormModule: null,
  tacticPanel: ConvictionCandleTacticPanel,
  addTacticPanel: null,
  wrapper: ConvictionCandleWrapper,
  chartSoftOrderComponent: ConvictionCandleLine,
  documentation: ConvictionCandleDoc,
  alertDetailsComponent: null, //todo

  //functions
  setupDetailParser: null, //todo
  validateFunction: validateConvictionCandle,
};
